<template>
  <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container" @wheel.prevent="handleScroll">
    <slot></slot>
  </el-scrollbar>
</template>

<script>
const tagAndTagSpacing = 4; // tagAndTagSpacing

export default {
  name: 'ScrollPane',
  data() {
    return {
      left: 0,
    };
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer;
    },
  },

  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40;
      const $scrollWrapper = this.scrollWrapper;
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4;
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el;
      const $containerWidth = $container.offsetWidth;
      const $scrollWrapper = this.scrollWrapper;
      const tagList = this.$parent.$refs.tag;
      if (!tagList) return;

      const tags = Array.isArray(tagList) ? tagList : [tagList];

      let firstTag = null;
      let lastTag = null;

      if (tags.length > 0) {
        firstTag = tags[0];
        lastTag = tags[tags.length - 1];
      }

      // Tags are now native DOM elements (span), not component instances
      const getEl = (tag) => tag.$el || tag;

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0;
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth;
      } else {
        const currentIndex = tags.findIndex(item => item === currentTag);
        const prevTag = tags[currentIndex - 1];
        const nextTag = tags[currentIndex + 1];

        if (nextTag) {
          const nextEl = getEl(nextTag);
          const afterNextTagOffsetLeft = nextEl.offsetLeft + nextEl.offsetWidth + tagAndTagSpacing;
          if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
            $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth;
          }
        }

        if (prevTag) {
          const prevEl = getEl(prevTag);
          const beforePrevTagOffsetLeft = prevEl.offsetLeft - tagAndTagSpacing;
          if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
            $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  width: 100%;
  :deep(.el-scrollbar__bar) {
    bottom: 0px;
  }
  :deep(.el-scrollbar__wrap) {
    height: 49px;
  }
}
</style>
